import { useState, useEffect } from 'react';

import { Label } from 'src/components/label';
import { suspiciousLoginApi } from 'src/api/suspiciousLogin.api';

const REFRESH_MS = 60_000;

/**
 * Pending suspicious-login counter. Fetches its own count (mount + every 60s).
 * All errors are swallowed — the badge must never break its host (e.g. when the
 * backend endpoint isn't deployed yet → 404).
 */
export function SuspiciousLoginPendingBadge() {
  const [count, setCount] = useState(0);

  useEffect(() => {
    let cancelled = false;

    const fetchCount = async () => {
      try {
        const pending = await suspiciousLoginApi.getPendingCount();
        if (!cancelled) setCount(pending);
      } catch {
        // silent — host must keep working without the badge
      }
    };

    fetchCount();
    const handle = setInterval(fetchCount, REFRESH_MS);
    return () => {
      cancelled = true;
      clearInterval(handle);
    };
  }, []);

  if (count <= 0) return null;

  return <Label color="error">{count}</Label>;
}
